<template>
  <div>
    <b-overlay :show="loading" spinner-variant="primary" blur="0" opacity=".75" rounded="sm">
      <b-alert show variant="info" class="mb-2 p-2">
        <div class="d-flex align-items-center">
          <feather-icon icon="InfoIcon" size="16" class="mr-1" />
          <span>{{
            t('Select service provider and customer to create new order price or view saved prices')
          }}</span>
        </div>
      </b-alert>
      <b-row>
        <b-col cols="12" md="6">
          <b-form-group :label="t('Provider')" label-for="provider-select">
            <v-select
              v-model="selectedProvider"
              :options="providers"
              :reduce="provider => provider.value"
              :label="'text'"
              :placeholder="t('Select Provider')"
              :loading="loading"
            />
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6">
          <b-form-group :label="t('Customer')" label-for="customer-select">
            <v-select
              v-model="selectedCustomer"
              :options="customers"
              :reduce="customer => customer.value"
              :label="'text'"
              :placeholder="t('Select Customer')"
              :loading="loading"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="12" class="d-flex justify-content-end">
          <b-button
            variant="primary"
            :disabled="!selectedProvider || !selectedCustomer"
            @click="handleContinue"
          >
            {{ t('Continue') }}
            <feather-icon icon="ArrowRightIcon" size="16" class="ml-1" />
          </b-button>
        </b-col>
      </b-row>
    </b-overlay>
  </div>
</template>

<script>
import { BRow, BCol, BFormGroup, BButton, BAlert } from 'bootstrap-vue';
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import useService from '@/auth/service/useService';
import vSelect from 'vue-select';
import { helper } from '@core/mixins/helper';

export default {
  name: 'SalePricesInstructions',
  components: {
    BRow,
    BCol,
    BFormGroup,
    BButton,
    BAlert,
    vSelect
  },
  mixins: [helper],
  data() {
    return {
      selectedProvider: null,
      selectedCustomer: null,
      providers: [],
      customers: [],
      loading: false
    };
  },
  methods: {
    handleContinue() {
      if (this.selectedProvider && this.selectedCustomer) {
        this.$router.push({
          name: 'sale-prices-instructions-detail',
          params: {
            providerId: this.selectedProvider,
            customerId: this.selectedCustomer
          }
        });
      }
    }
  },
  async created() {
    try {
      this.loading = true;

      const [providersResponse, customersResponse] = await Promise.all([
        useService.getAllProviders({ paginated: false }).catch(() => ({ data: [] })),
        useService.getAllCustomers({ paginated: false }).catch(() => ({ data: [] }))
      ]);

      this.providers = (providersResponse?.data || []).map(provider => ({
        text: provider.name,
        value: provider.id
      }));

      this.customers = (customersResponse?.data || []).map(customer => ({
        text: customer.name,
        value: customer.id
      }));
    } catch (error) {
      this.showErrorMessage(error);
    } finally {
      this.loading = false;
    }
  },
  setup() {
    const { t } = useI18nUtils();
    return { t };
  }
};
</script>

<style lang="scss" scoped>
.v-select {
  width: 100%;
}
</style>
